// decorators/entity.ts
import { registerEntity } from "../metadata/register.js";
function Entity(options = {}) {
  return (target) => {
    registerEntity(target, options);
  };
}
export {
  Entity
};
